import { createAsyncAction, takeOnce } from 'react-async-client';
import { takeEvery } from 'redux-saga/effects';

import * as actions from 'constants/actionTypes';

import * as handlers from './httpHandlers/handlers';
import * as userHandlers from './httpHandlers/userHandlers';
import * as catalogHandlers from './httpHandlers/catalogHandlers';
import * as projectsHandlers from './httpHandlers/projectsHandlers';

export const postLogin = createAsyncAction(actions.POST_LOGIN, userHandlers.postLogin);
export const postPasswordReset = createAsyncAction(actions.POST_PASSWORD_RESET, userHandlers.postPasswordReset);
export const patchPasswordReset = createAsyncAction(actions.PATCH_PASSWORD_RESET, userHandlers.patchPasswordReset);

export const postUser = createAsyncAction(actions.POST_USER, userHandlers.postUser);
export const patchUser = createAsyncAction(actions.PATCH_USER, userHandlers.patchUser);
export const getUser = createAsyncAction(actions.GET_USER, userHandlers.getUser);

export const getUserBilling = createAsyncAction(actions.GET_USER_BILLING, userHandlers.getUserBilling);
export const postUserBilling = createAsyncAction(actions.POST_USER_BILLING, userHandlers.postUserBilling);
export const patchUserBilling = createAsyncAction(actions.PATCH_USER_BILLING, userHandlers.patchUserBilling);

export const getDictionaries = createAsyncAction(actions.GET_DICTIONARIES, userHandlers.getDictionaries, {}, takeOnce);

export const getProducts = createAsyncAction(actions.GET_PRODUCTS, catalogHandlers.getProducts);
export const getProductList = createAsyncAction(actions.GET_PRODUCT_LIST, catalogHandlers.getProductList);
export const getShowcases = createAsyncAction(actions.GET_SHOWCASES, catalogHandlers.getShowcases);

export const getDistributors = createAsyncAction(actions.GET_DISTRIBUTORS, handlers.getDistributors);
export const getCities = createAsyncAction(actions.GET_CITIES, handlers.getCities);

export const getProjects = createAsyncAction(actions.GET_PROJECTS, projectsHandlers.getProjects);
export const postProject = createAsyncAction(actions.POST_PROJECT, projectsHandlers.postProject);
export const patchProject = createAsyncAction(actions.PATCH_PROJECT, projectsHandlers.patchProject);

export const getApplications = createAsyncAction(actions.GET_APPLICATIONS, projectsHandlers.getApplications, {}, takeEvery);
export const postApplication = createAsyncAction(actions.POST_APPLICATION, projectsHandlers.postApplication);
export const patchApplication = createAsyncAction(actions.PATCH_APPLICATION, projectsHandlers.patchApplication);

export const sendFeedback = createAsyncAction(actions.SEND_FEEDBACK, userHandlers.sendFeedback);

export const getNotifications = createAsyncAction(actions.GET_NOTIFICATIONS, userHandlers.getNotifications);
export const markNotifications = createAsyncAction(actions.POST_NOTIFICATIONS_MARK, userHandlers.markNotifications);
export const getMessages = createAsyncAction(actions.GET_MESSAGES, projectsHandlers.getMessages);
export const postMessage = createAsyncAction(actions.POST_MESSAGE, projectsHandlers.postMessage);

export const addCheck = createAsyncAction(actions.ADD_CHECK, userHandlers.addCheck);

export const getBonuses = createAsyncAction(actions.GET_BONUSES, userHandlers.getBonuses);

export const sendSms = createAsyncAction(actions.SEND_SMS, userHandlers.sendSms);

export const getAllApplications = createAsyncAction(actions.GET_ALL_APPLICATIONS, userHandlers.getAllApplications);



// WEBPACK FOOTER //
// ./src/actions/asyncActions.js